module.exports = __webpack_public_path__ + "img/b1.22d55632.jpg";